import React, {createContext, useContext, ReactNode} from 'react'

interface BillingContextType {
  triggerRefetch: () => void
  onChildRefetch?: () => void
}

const BillingContext = createContext<BillingContextType | undefined>(undefined)

export const useBillingRefetch = () => {
  const context = useContext(BillingContext)
  // Return undefined if not in provider instead of throwing error
  return context
}

interface BillingProviderProps {
  children: ReactNode
  onRefetch: () => void
  onChildRefetch?: () => void
}

export const BillingProvider: React.FC<BillingProviderProps> = ({
  children,
  onRefetch,
  onChildRefetch,
}) => {
  const triggerRefetch = () => {
    onRefetch()
    // Also trigger child refetch if available
    if (onChildRefetch) {
      onChildRefetch()
    }
  }

  return (
    <BillingContext.Provider value={{triggerRefetch, onChildRefetch}}>
      {children}
    </BillingContext.Provider>
  )
}
